import { Badge } from "@/components/ui/badge";
import { Building2, Bitcoin, BarChart3, Coins } from "lucide-react";

export function AssetIcon({ type }: { type: string }) {
  switch (type) {
    case "stock":
      return <Building2 className="h-4 w-4" />;
    case "etf":
      return <BarChart3 className="h-4 w-4" />;
    case "fund":
      return <BarChart3 className="h-4 w-4" />;
    case "crypto":
      return <Bitcoin className="h-4 w-4" />;
    case "fiat":
      return <Coins className="h-4 w-4" />;
    default:
      return <BarChart3 className="h-4 w-4" />;
  }
}

export function AssetTypeBadge({ type }: { type: string }) {
  const variants: Record<string, string> = {
    stock: "bg-blue-500/10 text-blue-500 border-blue-500/20",
    etf: "bg-purple-500/10 text-purple-500 border-purple-500/20",
    fund: "bg-violet-500/10 text-violet-500 border-violet-500/20",
    crypto: "bg-orange-500/10 text-orange-500 border-orange-500/20",
    fiat: "bg-green-500/10 text-green-500 border-green-500/20",
    index: "bg-cyan-500/10 text-cyan-500 border-cyan-500/20",
  };

  return (
    <Badge variant="outline" className={variants[type] || ""}>
      {type.toUpperCase()}
    </Badge>
  );
}
